<template>
    <kt-row style="padding-right: 25px;display: block" v-if="services">
        <div v-for="(service,index) in services" v-bind:key="index">
            <kt-row>
                <kt-col lg="3" md="5" sm="6" xs="12" style="margin-top: 34px">
                    <p>
                        {{ $t('application.services.' + service) }} {{ (service === 'iban_to_account') ? '(ست پی = استعلام شبا)' : '' }}
                    </p>
                </kt-col>
                <kt-col lg="9" md="7" sm="6" xs="12">
                    <div v-for="provider in getProviders(service)" v-bind:key="provider">
                        <kt-row>
                            <kt-col lg="4" md="4" sm="4" xs="6">
                                <kt-form-group ref="provider">
                                    <kt-form-label for="provider">
                                        {{ $t('application.provider') }}
                                    </kt-form-label>
                                    <kt-form-control
                                        :value="providerTypeStr.get(provider)"
                                        disabled
                                        :id="index"></kt-form-control>
                                </kt-form-group>
                            </kt-col>
                            <kt-col lg="4" md="4" sm="4" xs="6">
                                <kt-form-group ref="company_wage">
                                    <kt-form-label for="company_wage">
                                        {{ $t('application.company_wage') }}
                                    </kt-form-label>
                                    <kt-form-control
                                        v-model="settings[service][provider].company_wage"
                                        :name="service+'_'+provider+'_company_wage'"
                                    ></kt-form-control>
                                </kt-form-group>
                            </kt-col>
                            <kt-col lg="4" md="4" sm="4" xs="6">
                                <kt-form-group ref="provider_wage">
                                    <kt-form-label for="provider_wage">
                                        {{ $t('application.provider_wage') }}
                                    </kt-form-label>
                                    <kt-form-control
                                        v-model="settings[service][provider].provider_wage"
                                        :name="service+'_'+provider+'_provider_wage'"
                                    ></kt-form-control>
                                </kt-form-group>
                            </kt-col>
                        </kt-row>
                    </div>
                </kt-col>
            </kt-row>
            <hr>
        </div>
    </kt-row>
</template>

<script>
import {applicationServiceStatus, providerTypeStr} from '@/constants/openBanking'
import {bankIdStr} from '@/constants/bankId'

export default {
    props: {
        services: {
            required: true,
        },
        settings: {
            required: true
        },
        service_bank_providers: {
            required: true
        }
    },
    mounted() {
    },
    computed: {
        bankIdStr() {
            return bankIdStr
        },
    },
    methods: {
        getProviders(service) {
            return Object.keys(this.service_bank_providers[service])
        },
    },
    data() {
        return {
            applicationServiceStatus,
            providerTypeStr
        }
    }
}
</script>

<style>

</style>